module.exports = __webpack_public_path__ + "static/media/crocodile(6).0614ba57.PNG";